import { Box, BoxProps, SxProps, Theme } from "@mui/material";
import { toSxArray } from "src/utils/mui/sx/sx";

interface ISpacedContainerProps extends BoxProps {
    sx?: SxProps<Theme>;
}

export const SpacedContainer = ({ children, sx, ...boxProps }: ISpacedContainerProps) => {
    return (
        <Box
            {...boxProps}
            sx={[
                {
                    px: 2,
                    pb: 2,
                    gap: 2,
                    display: "flex",
                    flexDirection: "column",
                },
                ...toSxArray(sx),
            ]}
        >
            {children}
        </Box>
    );
};
